var map = {
	"./count": [
		540,
		7
	],
	"./count.vue": [
		540,
		7
	],
	"./free_drawing": [
		541,
		6
	],
	"./free_drawing.vue": [
		541,
		6
	],
	"./highlight": [
		542,
		5
	],
	"./highlight.vue": [
		542,
		5
	],
	"./image": [
		543,
		4
	],
	"./image.vue": [
		543,
		4
	],
	"./layer-picker": [
		544,
		15
	],
	"./layer-picker.vue": [
		544,
		15
	],
	"./line": [
		545,
		3
	],
	"./line.vue": [
		545,
		3
	],
	"./stamp": [
		546,
		2
	],
	"./stamp.vue": [
		546,
		2
	],
	"./text": [
		210,
		0
	],
	"./text.vue": [
		210,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1305;


//////////////////
// WEBPACK FOOTER
// ./src/components/project/notes/templates lazy ^\.\/.*$
// module id = 1305
// module chunks = 21